import { SeoProps } from "../../components/layout/SEO";
import { getMultiChoice } from "../../lib/multichoice";
import { useHomePageMetadata } from "../../lib/useHomePageMetadata";
import { KontentPageMetadata } from "../../types";
import { PageQueryData } from "./PageTypes";

export function getSeoProps({
  pageData,
  elements,
  systemData,
}: {
  pageData:
    | PageQueryData["kontentItemPage"]["elements"]
    | PageQueryData["kontentItemHomepage"]["elements"];
  elements: KontentPageMetadata;
  systemData: PageQueryData["kontentItemContentPage"]["system"];
}): SeoProps {
  const defaultMetadata = useHomePageMetadata();
  const pageTitle = pageData?.title?.value || "";
  const pageDescription =
    elements?.page_metadata__page_description?.value ||
    defaultMetadata.pageDescription;

  const pageUrl = pageData?.url?.url
    ? "https://www.emprisebank.com" +
      pageData?.url?.url +
      (pageData.url.url.slice(-1) === "/" ? "" : "/")
    : "https://www.emprisebank.com/";

  const seo: SeoProps = {
    pageTitle: pageTitle,
    pageUrl: pageUrl,
    pageDescription: pageDescription,
    canonicalUrl: elements?.page_metadata__canonical_url?.value,
    robotsNoIndex:
      getMultiChoice(elements?.page_metadata__robots_index) === "noindex",
    robotsNoFollow:
      getMultiChoice(elements?.page_metadata__robots_follow) === "nofollow",
    sitemapInclude:
      getMultiChoice(elements?.page_metadata__sitemap_include) != "exclude",
    socialShareImage:
      elements?.page_metadata__social_share_image?.value[0] ||
      defaultMetadata.socialShareImage,
    socialShareTitle:
      elements?.page_metadata__social_share_title?.value ||
      pageTitle ||
      defaultMetadata.socialShareTitle,
    socialShareDescription:
      elements?.page_metadata__social_share_description?.value ||
      elements?.page_metadata__page_description?.value ||
      defaultMetadata.socialShareDescription,
    twitterCardType: getMultiChoice(elements?.page_metadata__twitter_card_type),
    lastModified: systemData.last_modified,
    publishDate: pageData?.display_publish_date?.value || "",
    breadcrumbs: pageData?.breadcrumbs || [],
  };

  return seo;
}
